export default "__VITE_ASSET__DPGKpJPC__"